import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { RenderViewLensParams } from '@upright/common/renderer/component-types/types-render-view-lenses';
import { ImpactLensProfile } from '@upright/ui/common/upright/core/impact-lens-profile';
import { LensOptions, SingleEntityLensData } from '@upright/ui/common/upright/core/impact-lens-profile/types';
import { getLens } from '@upright/ui/common/upright/core/impact-lenses';
import { LensSelectionStateHandler } from '@upright/ui/common/upright/core/impact-lenses/selection-hook';
import { useRenderViewContext } from '../../context';
import { RenderViewTitleMaybe } from '../shared/render-view-title-maybe';
import { useGetLensSelectionStateHandler } from './use-get-lens-selection-state-handler';

interface Props<T extends ImpactLensType> {
  lensType: T;
  lensData: SingleEntityLensData<T>;
  lensOptions?: Partial<LensOptions<T>>;
  params: RenderViewLensParams;
}

export function RenderViewLens<T extends ImpactLensType = ImpactLensType>(props: Props<T>) {
  const { params } = props;
  const { options } = useRenderViewContext();

  const selectionStateHandler: LensSelectionStateHandler = useGetLensSelectionStateHandler(
    params,
    params.componentType,
  );

  const width = options.width || 1000;

  const lensOptions: LensOptions<T> = {
    ...props.lensOptions,
    type: props.lensType,
    selectionStateHandler: selectionStateHandler,
    hideClearSelectionButton: !options.showControlUi,
    hideTopDescriptionArea: true,
    disableImpactTitleInteraction: true,
    disableStateClearingOnOutsideClick: true,
    hideTooltips: true,
    scoreUnit: params.scoreUnit,
  };

  return (
    <div style={{ width }}>
      <RenderViewTitleMaybe params={params} />
      <ImpactLensProfile
        lens={getLens(props.lensType)}
        data={props.lensData}
        width={width}
        lensIndex={0}
        options={lensOptions}
      />
    </div>
  );
}
